import type React from "react";
import { useEffect } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import type translations from "../translations/translations.json";
import DefaultTruckGroup from "./DefaultTruckGroup";
import { searchTrucks } from "../store/features/truckSlice";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../store";
type TranslationKeys = keyof typeof translations.en;

const DefaultTruckGroupsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const type = searchParams.get("type") as "WINGBOX" | "LOSBAK" | "DUMP" | null;
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(
      searchTrucks({ filters: { type: type || "" }, pagination: { page: 1, pageSize: 100 } }),
    );
  }, [type, dispatch]);

  if (!type) {
    return (
      <Box>
        <Box sx={{ mb: 4 }} />
      </Box>
    );
  }

  return (
    <Box>
      <DefaultTruckGroup
        defaultType={type}
        title={t(`${type} Trucks` as TranslationKeys)}
        hideTypeFilter={true}
      />
    </Box>
  );
};

export default DefaultTruckGroupsPage;
